import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';

import { getApiUrl, API_URL } from '@/utils/api';
import ApiBase from './ApiBase';

export default class HomepagelayoutService extends ApiBase {
  static baseUrl = getApiUrl(API_URL.ADMIN, '/homepagelayout');

  getActiveByStoreId(storeId: string) {
    const searchParams = new URLSearchParams({ storeId });

    return this.api.getJSON(`${HomepagelayoutService.baseUrl}/activeByStoreId?${searchParams.toString()}`).pipe(
      catchError(() => of({}))
    );
  }
}
